import React, { useRef } from "react";
import { DragSourceMonitor } from "react-dnd";
import styled from "styled-components";

import { Stem } from "@examspark/types";

import { useDrag } from "../../hooks/useDnd";

import { DndItem } from "./Token";

const Styled = styled.div<{ allowMultipleTokens?: boolean }>`
  position: relative;
`;

const StyledGraphicToken = styled.img<{ allowMultipleTokens?: boolean }>`
  box-sizing: border-box;
  border: 1px solid transparent;

  cursor: move;
`;

type GraphicGapTokenProps = {
  data: Stem.Token;
  gapId?: string;
  useDragType: string;
  instanceId?: string;
  onEnd?: (item: DndItem | undefined, monitor: DragSourceMonitor) => void;

  allowMultipleTokens?: boolean;
};
const GraphicGapToken = (props: GraphicGapTokenProps) => {
  const ref = useRef(null);

  useDrag(ref, {
    item: {
      type: props.useDragType,
      id: props.data.id,
      instanceId: props.instanceId,
      gapId: props.gapId,
    },
    end: (item, monitor) => {
      props.onEnd?.(item, monitor);
    },
  });

  return (
    <Styled allowMultipleTokens={props.allowMultipleTokens}>
      <StyledGraphicToken
        allowMultipleTokens={props.allowMultipleTokens}
        ref={ref}
        alt=""
        src={props.data.src}
        width={props.data.metadata.width}
        height={props.data.metadata.height}
      />
    </Styled>
  );
};

export default GraphicGapToken;
